import React, { FC, ReactNode } from 'react';

import clsx from 'clsx';

import styles from './Typography.module.scss';
import { DesignSystemTypography } from '../../tokens/tokens';

type Props = {
  variant: DesignSystemTypography;
  tag?: keyof JSX.IntrinsicElements;
  children: ReactNode;
  className?: string;
};

export const Typography: FC<Props> = ({
  variant,
  tag: Tag = 'div',
  children,
  className,
}) => {
  return (
    <Tag className={clsx(styles.typography, styles[variant], className)}>
      {children}
    </Tag>
  );
};

export type { Props as TypographyProps };
